var _rect, _circle, _path, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlacementStaplesPortraitWidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 116,
    viewBox: "0 0 87 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 116,
    rx: 3.86667,
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.4671,
    cy: 58.0003,
    r: 27.0667,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8547 70.5996H56.7011V55.6588C56.7011 51.9777 56.7011 43.966 45.6037 43.966C41.4896 43.966 37.4296 45.2111 34.5605 48.1343L37.9709 51.5447C39.7032 49.9207 42.1933 48.838 44.9 48.838C48.3645 48.838 50.8547 50.5161 50.8547 53.71V54.4137H49.2307C42.7347 54.4137 32.8824 55.0092 32.8824 63.454C32.8824 68.5967 37.5379 71.2492 42.3557 71.2492C45.8203 71.2492 48.8517 69.95 50.6923 67.0268H50.8547V70.5996ZM50.4757 60.4225C50.4757 64.0495 48.3645 66.3772 43.9256 66.3772C41.8144 66.3772 39.3784 65.3487 39.3784 62.9668C39.3784 59.2316 45.5496 58.9609 49.1224 58.9609H50.4757V60.4225Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73.9502,
    y: 7.25,
    width: 2.9,
    height: 15.4667,
    rx: 1.45,
    transform: "rotate(90 73.9502 7.25)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4834,
    y: 7.25,
    width: 2.9,
    height: 15.4667,
    rx: 1.45,
    transform: "rotate(90 29.4834 7.25)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacementStaplesPortraitWidth);
export default __webpack_public_path__ + "static/media/placement-staples-portrait-width.1abca21d296aa7a0da566b78c3bc1e8c.svg";
export { ForwardRef as ReactComponent };